import React, { FC, useState } from 'react'
import { Button, Col, Row } from 'antd'
import { EndCustomer, EndCustomerFormValues } from '../../../types'
import { EndCustomerAccountForm, ResellerCard } from '../../../components'

import styles from './index.module.less'

interface AccountProps {
	endCustomer: EndCustomer
	submit(values: EndCustomerFormValues): Promise<void>
}

const Account: FC<AccountProps> = ({ endCustomer, submit }) => {
	const [isEditMode, setEditMode] = useState<boolean>(false)

	const onSubmit = async (values: EndCustomerFormValues) => {
		await submit(values)
		setEditMode(false)
	}

	const DisplayView = () => (
		<Row type='flex' justify='space-between'>
			<Col>
				<dl>
					<dt>Name:</dt>
					<dd className={styles.detailLabel}>{endCustomer?.name}</dd>
					<dt>Description:</dt>
					<dd className={styles.detailLabel}>{endCustomer?.description}</dd>
					<dt>Address:</dt>
					<dd>
						<span>{endCustomer?.address1}</span>
						<br />
						<span>{endCustomer?.address2}</span>
						<br />
						<span>{endCustomer?.postcode}</span>
					</dd>
				</dl>
			</Col>
			<Col>
				<Button icon={'edit'} onClick={() => setEditMode(true)}>
					Edit {endCustomer.name}
				</Button>
			</Col>
		</Row>
	)

	return (
		<Row gutter={24}>
			<Col xxl={18} xl={16} lg={14} md={24}>
				{!isEditMode ? (
					<DisplayView />
				) : (
					<Row>
						<Col xxl={12} xl={16} lg={24} md={24}>
							<EndCustomerAccountForm endCustomer={endCustomer} submit={onSubmit} cancel={() => setEditMode(false)} />
						</Col>
					</Row>
				)}
			</Col>
			<Col xxl={6} xl={8} lg={10} md={24}>
				<Row>
					<ResellerCard id={endCustomer.reseller_id} />
				</Row>
			</Col>
		</Row>
	)
}

export default Account
